// Central registry of mountable components.
// Add new components here so they can be referenced by name in ERB.

import UserCard from "./UserCard";
import PowerCalculator from "./PowerCalculator";
import PrecisionCalculator from "./PrecisionCalculator";
import ConceptChart from "./ConceptChart";
import ResultDecoder from "./ResultDecoder";
import MethodChooser from "./MethodChooser";

export default {
	UserCard,
	PowerCalculator,
	PrecisionCalculator,
	ConceptChart,
	ResultDecoder,
	MethodChooser,
};
